module.exports = __webpack_public_path__ + "img/psxffu426km3skg83eh4clgd48zyjx8yut4a1506fa1-a17a-47d2-985a-c67345cb921c.686de8a6.png";